import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "41",
  height: "40",
  fill: "none",
  viewBox: "0 0 41 40"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M7.1 18.13c-1.311-1.308-3.54-1.308-4.983 0-1.312 1.308-1.312 3.531 0 4.839l9.836 9.677L14.445 35l2.491-2.354L40.15 10.153c1.311-1.308 1.311-3.531 0-4.839-1.312-1.308-3.541-1.308-4.984 0l-20.59 20.14z",
        "clip-rule": "evenodd"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M.8 0h40v40H.8z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }